// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7786f870","513":"9f3b57d3","703":"e3964cf8"}[chunkId] + ".chunk.js";
};